export default __webpack_public_path__ + "img/5ae9f49a64088e9d027d78ed8b0cb9b1.svg";